


















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "qMultiSelect",
  components: {},
  directives: {},
})
export default class qMultiSelect extends Vue {
  @Prop({
    default: () => {
      return "";
    },
  })
  title;
  @Prop({
    default: () => {
      return {};
    },
  })
  options;
  @Prop({
    default: () => {
      return [];
    },
  })
  defaultValue;

  show = false;
  selected = [];

  mounted() {
    console.log(this.options);
    this.selected = this.defaultValue;
  }

  @Watch("selected")
  changeSelected(value) {
    this.$emit("checked", value);
  }

  get selectedText() {
    let selectedText = "";

    this.selected.map(
      function (value) {
        selectedText = selectedText + this.options[value] + "、";
      }.bind(this)
    );

    return selectedText.slice(0, -1);
  }

  showDropdown() {
    this.show = !this.show;
  }
  hide() {
    this.show = false;
  }
}
